import { Fragment } from "react";
import { useTranslation } from "@1f/react-sdk";
import VaporTag from "@vapor/react-custom/VaporTag";
import Divider from "@vapor/react-material/Divider";
import Stack from "@vapor/react-material/Stack";
import Table from "@vapor/react-material/Table";
import TableBody from "@vapor/react-material/TableBody";
import TableCell from "@vapor/react-material/TableCell";
import TableContainer from "@vapor/react-material/TableContainer";
import TableHead from "@vapor/react-material/TableHead";
import TableRow from "@vapor/react-material/TableRow";
import Paper from "@vapor/react-material/Paper";
import Button from "@vapor/react-material/Button";
import Box from "@vapor/react-material/Box";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import ExtendedTabs from "@vapor/react-extended/ExtendedTabs";
import ExtendedTab from "@vapor/react-extended/ExtendedTab";
import {
	Search as SearchIcon,
	AddShoppingCart as AddShoppingCartIcon,
} from "@mui/icons-material";
import { Loading } from "../Loading";
import { NoData } from "../NoData";
import { v4 as uuidv4 } from "uuid";

export const BancaDatiTab = ({
	backDropInternalOpen,
	bancaDatiTabValue,
	bancaDatiResult,
	currentAnagrafica,
	hasBancaDatiAbb,
	bancaDatiAbbCredits,
	bancaDatiAbbProductsList,
	bancaDatiAbbProductBought,
	currentAnagraficheList,
	anagraficheBancaDatiList,
	handleChangeBancaDatiTab,
	handleCheckBancaDatiClick,
	handleDetailBancaDatiClick,
	handleBancaDatiBuyProduct,
}) => {
	const { t } = useTranslation();

	return (
		<Fragment>
			<Loading open={backDropInternalOpen} />
			<ExtendedTabs
				variant="standard"
				size="small"
				value={bancaDatiTabValue}
				onChange={handleChangeBancaDatiTab}
			>
				<ExtendedTab value="tabBdGratuite" label="Pubbliche" />
				<ExtendedTab
					value="tabBdPagamento"
					label="Business Information"
				/>
				<ExtendedTab value="tabBdResoconto" label="Riepilogo" />
			</ExtendedTabs>

			{bancaDatiTabValue === "tabBdGratuite" ? (
				<Fragment>
					<Stack direction="row" spacing={2} sx={{ mt: 2 }}>
						<Box flexGrow={1}></Box>
						<Button
							variant="contained"
							size="small"
							endIcon={<SearchIcon />}
							onClick={handleCheckBancaDatiClick}
							disabled={currentAnagrafica.cf === ""}
						>
							{t("fascicolo.fascicoloAdd.verifica")}
						</Button>
					</Stack>

					<Divider variant="standard" sx={{ mt: 2, mb: 1 }} />

					<TableContainer component={Paper} sx={{ width: "100%", mt: 4 }}>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell align="left" width="70%">
										<ExtendedTypography variant="subtitle2">
											{t("fascicolo.fascicoloAdd.bancaDati")}
										</ExtendedTypography>
									</TableCell>
									<TableCell align="center" width="30%">
										<ExtendedTypography variant="subtitle2">
											{t("fascicolo.fascicoloAdd.esito")}
										</ExtendedTypography>
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{!currentAnagrafica.isPg ? (
									<Fragment>
										<TableRow hover>
											<TableCell align="left" width="70%">
												<ExtendedTypography variant="subtitle2">
													{t(
														"fascicolo.fascicoloAdd.administratoriRaginali",
													)}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="30%">
												<VaporTag
													variant="ghost"
													label={
														bancaDatiResult.Pep_Regionali
															? "Verifica completata"
															: "-"
													}
													type={
														bancaDatiResult.Pep_Regionali
															? "islamicGreen"
															: "blueSapphire"
													}
													clickable={bancaDatiResult.Pep_Regionali}
													onClick={() =>
														handleDetailBancaDatiClick(
															"PEP - Amministratori Regionali",
														)
													}
												/>
											</TableCell>
										</TableRow>
										<TableRow hover>
											<TableCell align="left" width="70%">
												<ExtendedTypography variant="subtitle2">
													{t(
														"fascicolo.fascicoloAdd.administratoriMetropolitani",
													)}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="30%">
												<VaporTag
													variant="ghost"
													label={
														bancaDatiResult.Pep_Metropolitani
															? "Verifica completata"
															: "-"
													}
													type={
														bancaDatiResult.Pep_Metropolitani
															? "islamicGreen"
															: "blueSapphire"
													}
													clickable={bancaDatiResult.Pep_Metropolitani}
													onClick={() =>
														handleDetailBancaDatiClick(
															"PEP - Amministratori Metropolitani",
														)
													}
												/>
											</TableCell>
										</TableRow>
										<TableRow hover>
											<TableCell align="left" width="70%">
												<ExtendedTypography variant="subtitle2">
													{t(
														"fascicolo.fascicoloAdd.administratoriProvinciali",
													)}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="30%">
												<VaporTag
													variant="ghost"
													label={
														bancaDatiResult.Pep_Provinciali
															? "Verifica completata"
															: "-"
													}
													type={
														bancaDatiResult.Pep_Provinciali
															? "islamicGreen"
															: "blueSapphire"
													}
													clickable={bancaDatiResult.Pep_Provinciali}
													onClick={() =>
														handleDetailBancaDatiClick(
															"PEP - Amministratori Provinciali",
														)
													}
												/>
											</TableCell>
										</TableRow>
										<TableRow hover>
											<TableCell align="left" width="70%">
												<ExtendedTypography variant="subtitle2">
													{t(
														"fascicolo.fascicoloAdd.administratoriComunali",
													)}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="30%">
												<VaporTag
													variant="ghost"
													label={
														bancaDatiResult.Pep_Comunali
															? "Verifica completata"
															: "-"
													}
													type={
														bancaDatiResult.Pep_Comunali
															? "islamicGreen"
															: "blueSapphire"
													}
													clickable={bancaDatiResult.Pep_Comunali}
													onClick={() =>
														handleDetailBancaDatiClick(
															"PEP - Amministratori Comunali",
														)
													}
												/>
											</TableCell>
										</TableRow>
										<TableRow hover>
											<TableCell align="left" width="70%">
												<ExtendedTypography variant="subtitle2">
													{t("fascicolo.fascicoloAdd.maggiorOrgano")}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="30%">
												<VaporTag
													variant="ghost"
													label={
														bancaDatiResult.Pep_MaggiorOrgano
															? "Verifica completata"
															: "-"
													}
													type={
														bancaDatiResult.Pep_MaggiorOrgano
															? "islamicGreen"
															: "blueSapphire"
													}
													clickable={bancaDatiResult.Pep_MaggiorOrgano}
													onClick={() =>
														handleDetailBancaDatiClick(
															"PEP - Maggior Organo",
														)
													}
												/>
											</TableCell>
										</TableRow>
										<TableRow hover>
											<TableCell align="left" width="70%">
												<ExtendedTypography variant="subtitle2">
													{t("fascicolo.fascicoloAdd.organiStraordinari")}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="30%">
												<VaporTag
													variant="ghost"
													label={
														bancaDatiResult.Pep_OrganiStraordinari
															? "Verifica completata"
															: "-"
													}
													type={
														bancaDatiResult.Pep_OrganiStraordinari
															? "islamicGreen"
															: "blueSapphire"
													}
													clickable={
														bancaDatiResult.Pep_OrganiStraordinari
													}
													onClick={() =>
														handleDetailBancaDatiClick(
															"PEP - Organi Straordinari in carica",
														)
													}
												/>
											</TableCell>
										</TableRow>
										<TableRow hover>
											<TableCell align="left" width="70%">
												<ExtendedTypography variant="subtitle2">
													{t("fascicolo.fascicoloAdd.sindaci")}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="30%">
												<VaporTag
													variant="ghost"
													label={
														bancaDatiResult.Pep_SindaciInCarica
															? "Verifica completata"
															: "-"
													}
													type={
														bancaDatiResult.Pep_SindaciInCarica
															? "islamicGreen"
															: "blueSapphire"
													}
													clickable={bancaDatiResult.Pep_SindaciInCarica}
													onClick={() =>
														handleDetailBancaDatiClick(
															"PEP - Sindaci in carica",
														)
													}
												/>
											</TableCell>
										</TableRow>
										<TableRow hover>
											<TableCell align="left" width="70%">
												<ExtendedTypography variant="subtitle2">
													{t("fascicolo.fascicoloAdd.caricheComunali")}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="30%">
												<VaporTag
													variant="ghost"
													label={
														bancaDatiResult.Pep_Comune
															? "Verifica completata"
															: "-"
													}
													type={
														bancaDatiResult.Pep_Comune
															? "islamicGreen"
															: "blueSapphire"
													}
													clickable={bancaDatiResult.Pep_Comune}
													onClick={() =>
														handleDetailBancaDatiClick("PEP - Comune")
													}
												/>
											</TableCell>
										</TableRow>
									</Fragment>
								) : null}
								<TableRow hover>
									<TableCell align="left" width="70%">
										<ExtendedTypography variant="subtitle2">
											{t("fascicolo.fascicoloAdd.unsc")}
										</ExtendedTypography>
									</TableCell>
									<TableCell align="center" width="30%">
										<VaporTag
											variant="ghost"
											label={
												bancaDatiResult.UNSC ? "Verifica completata" : "-"
											}
											type={
												bancaDatiResult.UNSC
													? "islamicGreen"
													: "blueSapphire"
											}
											clickable={bancaDatiResult.UNSC}
											onClick={() =>
												handleDetailBancaDatiClick(
													"United Nations Security Council Consolidated List",
												)
											}
										/>
									</TableCell>
								</TableRow>
								<TableRow hover>
									<TableCell align="left" width="70%">
										<ExtendedTypography variant="subtitle2">
											{t("fascicolo.fascicoloAdd.ofac")}
										</ExtendedTypography>
									</TableCell>
									<TableCell align="center" width="30%">
										<VaporTag
											variant="ghost"
											label={
												bancaDatiResult.OFAC ? "Verifica completata" : "-"
											}
											type={
												bancaDatiResult.OFAC
													? "islamicGreen"
													: "blueSapphire"
											}
											clickable={bancaDatiResult.OFAC}
											onClick={() =>
												handleDetailBancaDatiClick("OFAC Sanctions List")
											}
										/>
									</TableCell>
								</TableRow>
								<TableRow hover>
									<TableCell align="left" width="70%">
										<ExtendedTypography variant="subtitle2">
											{t("fascicolo.fascicoloAdd.sanctionsEU")}
										</ExtendedTypography>
									</TableCell>
									<TableCell align="center" width="30%">
										<VaporTag
											variant="ghost"
											label={
												bancaDatiResult.UE ? "Verifica completata" : "-"
											}
											type={
												bancaDatiResult.UE
													? "islamicGreen"
													: "blueSapphire"
											}
											clickable={bancaDatiResult.UE}
											onClick={() =>
												handleDetailBancaDatiClick("UE Sanctions List")
											}
										/>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Fragment>
			) : null}

			{bancaDatiTabValue === "tabBdPagamento" ? (
				<Fragment>
					{hasBancaDatiAbb ? (
						<Fragment>
							<Card sx={{ mb: 1, mt: 2 }}>
								<CardContent sx={{ p: 2 }}>
									<Stack direction="column" spacing={2}>
										<ExtendedTypography variant="titleSmall">
											{t("fascicolo.fascicoloAdd.credito")}{" "}
											{bancaDatiAbbCredits}
										</ExtendedTypography>
									</Stack>
								</CardContent>
							</Card>
							<TableContainer
								component={Paper}
								sx={{ width: "100%", mt: 4 }}
							>
								<Table size="small">
									<TableHead>
										<TableRow>
											<TableCell align="left" width="65%">
												<ExtendedTypography variant="subtitle2">
													{t("fascicolo.fascicoloAdd.bancaDati")}
												</ExtendedTypography>
											</TableCell>
											<TableCell align="center" width="35%">
												<ExtendedTypography variant="subtitle2">
													{t("fascicolo.fascicoloAdd.esito")}
												</ExtendedTypography>
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{bancaDatiAbbProductsList.length > 0
											? bancaDatiAbbProductsList.map((item) => (
													<TableRow key={uuidv4()} hover>
														<TableCell align="left" width="65%">
															{item.product === "NEGATIVITA" ? (
																<ExtendedTypography variant="subtitle2">
																	{t("fascicolo.fascicoloAdd.negativita")}
																</ExtendedTypography>
															) : null}
															{item.product === "PARTECIPAZIONI" ? (
																<ExtendedTypography variant="subtitle2">
																	{t(
																		"fascicolo.fascicoloAdd.partecipazioni",
																	)}
																</ExtendedTypography>
															) : null}
															{item.product === "STRUTTURA_SOCIETARIA" ? (
																<ExtendedTypography variant="subtitle2">
																	{t(
																		"fascicolo.fascicoloAdd.strutturaSocietaria",
																	)}
																</ExtendedTypography>
															) : null}
														</TableCell>
														<TableCell align="center" width="35%">
															{bancaDatiAbbProductBought &&
															item.product === "NEGATIVITA" ? (
																<VaporTag
																	variant="ghost"
																	label={
																		bancaDatiResult.Negativita
																			? "Disponibile"
																			: "-"
																	}
																	type={
																		bancaDatiResult.Negativita
																			? "islamicGreen"
																			: "blueSapphire"
																	}
																	clickable={bancaDatiResult.Negativita}
																	onClick={() =>
																		handleDetailBancaDatiClick(
																			item.product,
																		)
																	}
																/>
															) : null}

															{bancaDatiAbbProductBought &&
															item.product === "PARTECIPAZIONI" ? (
																<VaporTag
																	variant="ghost"
																	label={
																		bancaDatiResult.Partecipazioni
																			? "Disponibile"
																			: "-"
																	}
																	type={
																		bancaDatiResult.Partecipazioni
																			? "islamicGreen"
																			: "blueSapphire"
																	}
																	clickable={
																		bancaDatiResult.Partecipazioni
																	}
																	onClick={() =>
																		handleDetailBancaDatiClick(
																			item.product,
																		)
																	}
																/>
															) : null}

															{bancaDatiAbbProductBought &&
															item.product === "STRUTTURA_SOCIETARIA" ? (
																<VaporTag
																	variant="ghost"
																	label={
																		bancaDatiResult.StrutturaSocietaria
																			? "Disponibile"
																			: "-"
																	}
																	type={
																		bancaDatiResult.StrutturaSocietaria
																			? "islamicGreen"
																			: "blueSapphire"
																	}
																	clickable={
																		bancaDatiResult.StrutturaSocietaria
																	}
																	onClick={() =>
																		handleDetailBancaDatiClick(
																			item.product,
																		)
																	}
																/>
															) : null}

															{!bancaDatiAbbProductBought &&
															item.product === "NEGATIVITA" ? (
																<Button
																	variant="contained"
																	size="small"
																	endIcon={<AddShoppingCartIcon />}
																	onClick={() =>
																		handleBancaDatiBuyProduct(item)
																	}
																	disabled={currentAnagrafica.cf === ""}
																>
																	{t(
																		"fascicolo.fascicoloAdd.acquistaPer",
																	)}{" "}
																	{item.price}{" "}
																	{t("fascicolo.fascicoloAdd.crediti")}
																</Button>
															) : null}

															{!bancaDatiAbbProductBought &&
															item.product === "PARTECIPAZIONI" ? (
																<Button
																	variant="contained"
																	size="small"
																	endIcon={<AddShoppingCartIcon />}
																	onClick={() =>
																		handleBancaDatiBuyProduct(item)
																	}
																	disabled={currentAnagrafica.cf === ""}
																>
																	{t(
																		"fascicolo.fascicoloAdd.acquistaPer",
																	)}{" "}
																	{item.price}{" "}
																	{t("fascicolo.fascicoloAdd.crediti")}
																</Button>
															) : null}

															{!bancaDatiAbbProductBought &&
															item.product === "STRUTTURA_SOCIETARIA" ? (
																<Button
																	variant="contained"
																	size="small"
																	endIcon={<AddShoppingCartIcon />}
																	onClick={() =>
																		handleBancaDatiBuyProduct(item)
																	}
																	disabled={currentAnagrafica.cf === ""}
																>
																	{t(
																		"fascicolo.fascicoloAdd.acquistaPer",
																	)}{" "}
																	{item.price}{" "}
																	{t("fascicolo.fascicoloAdd.crediti")}
																</Button>
															) : null}
														</TableCell>
													</TableRow>
												))
											: null}
									</TableBody>
								</Table>
							</TableContainer>
						</Fragment>
					) : (
						<Card sx={{ mb: 1, mt: 2 }}>
							<CardContent sx={{ p: 2 }}>
								<Stack direction="column" spacing={2}>
									<ExtendedTypography variant="titleSmall">
										{t("fascicolo.fascicoloAdd.bussinessInfo")}
									</ExtendedTypography>
									<ExtendedTypography variant="body">
										{t("fascicolo.fascicoloAdd.bussinessInfoDesc")}
										<br />
										<ul>
											<li>
												{t("fascicolo.fascicoloAdd.bussinessInfoDesc1")}
											</li>
											<li>
												{t("fascicolo.fascicoloAdd.bussinessInfoDesc2")}
											</li>
											<li>
												{t("fascicolo.fascicoloAdd.bussinessInfoDesc3")}
											</li>
											<li>
												{t("fascicolo.fascicoloAdd.bussinessInfoDesc4")}
											</li>
											<li>
												{t("fascicolo.fascicoloAdd.bussinessInfoDesc5")}
											</li>
										</ul>
									</ExtendedTypography>
									<Button
										variant="contained"
										size="small"
										onClick={() =>
											window.open(
												"https://www.teamsystem.com/store/business-information/",
												"_blank",
												"noopener,noreferrer",
											)
										}
									>
										{t("fascicolo.fascicoloAdd.service")}
									</Button>
								</Stack>
							</CardContent>
						</Card>
					)}
				</Fragment>
			) : null}

			{bancaDatiTabValue === "tabBdResoconto" ? (
				<Fragment>
					{currentAnagraficheList.length > 0
						? currentAnagraficheList.map((item) => (
								<Fragment key={item.id}>
									<Stack
										direction="column"
										spacing={1}
										sx={{ mt: 2, mb: 1 }}
									>
										<ExtendedTypography variant="titleSmall">
											{item.isPg
												? item.denominazione
												: item.nome + " " + item.cognome}
										</ExtendedTypography>
										<Divider variant="standard" />
									</Stack>

									{anagraficheBancaDatiList.filter(
										(x) =>
											x.anagraficaId === item.id ||
											x.anagraficaId === item.parentId,
									).length > 0 ? (
										<TableContainer
											component={Paper}
											sx={{ width: "100%", mt: 4 }}
										>
											<Table size="small">
												<TableHead>
													<TableRow>
														<TableCell align="left" width="40%">
															<ExtendedTypography variant="subtitle2">
																{t("fascicolo.fascicoloAdd.bancaDati")}
															</ExtendedTypography>
														</TableCell>
														<TableCell align="left" width="30%">
															<ExtendedTypography variant="subtitle2">
																{t("fascicolo.fascicoloAdd.dati")}
															</ExtendedTypography>
														</TableCell>
														<TableCell align="center" width="30%">
															<ExtendedTypography variant="subtitle2">
																{t("fascicolo.fascicoloAdd.esito")}
															</ExtendedTypography>
														</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{anagraficheBancaDatiList
														.filter(
															(x) =>
																x.anagraficaId === item.id ||
																x.anagraficaId === item.parentId,
														)
														.map((item2) => (
															<TableRow key={uuidv4()} hover>
																<TableCell align="left" width="40%">
																	<ExtendedTypography variant="subtitle2">
																		{item2.repository}
																	</ExtendedTypography>
																</TableCell>
																<TableCell align="left" width="30%">
																	<ExtendedTypography variant="subtitle2">
																		{new Date(
																			item2.createdOn,
																		).toLocaleDateString()}
																	</ExtendedTypography>
																</TableCell>
																<TableCell align="center" width="30%">
																	{item2.infos === "" ? (
																		<VaporTag
																			variant="ghost"
																			label="Nessun risultato"
																			type="islamicGreen"
																		/>
																	) : (
																		<VaporTag
																			variant="ghost"
																			label="Visualizza"
																			type="islamicGreen"
																			clickable
																			onClick={() =>
																				handleDetailBancaDatiClick(item2)
																			}
																		/>
																	)}
																</TableCell>
															</TableRow>
														))}
												</TableBody>
											</Table>
										</TableContainer>
									) : (
										<NoData size="small" />
									)}
								</Fragment>
							))
						: null}
				</Fragment>
			) : null}
		</Fragment>
	);
};
